(() => {
  const root = document.querySelector('.bp-host');
  if (!root) return;

  const menuButton = root.querySelector('[data-bp-menu-button]');
  const mobileNav = root.querySelector('[data-bp-mobile-nav]');
  if (menuButton && mobileNav) {
    const closeMenu = () => {
      mobileNav.setAttribute('hidden', '');
      menuButton.setAttribute('aria-expanded', 'false');
    };
    menuButton.addEventListener('click', () => {
      const open = mobileNav.hasAttribute('hidden');
      if (open) mobileNav.removeAttribute('hidden');
      else mobileNav.setAttribute('hidden', '');
      menuButton.setAttribute('aria-expanded', String(open));
    });
    mobileNav.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  }

  root.querySelectorAll('[data-bp-purchase]').forEach((purchase) => {
    const packs = [...purchase.querySelectorAll('[data-bp-pack]')];
    const field = purchase.querySelector('[data-bp-variant-field]');
    const submit = purchase.querySelector('[data-bp-submit]');
    const status = purchase.querySelector('[data-bp-availability-status]');
    if (!packs.length || !field || !submit) return;

    const selectPack = (pack) => {
      packs.forEach((item) => item.setAttribute('aria-pressed', String(item === pack)));
      const variantId = pack.dataset.bpVariant || '';
      const available = pack.dataset.bpAvailable === 'true';
      const label = pack.dataset.bpLabel || 'Selected pack';
      const price = pack.dataset.bpPrice || '';
      field.value = variantId;
      submit.disabled = !variantId || !available;
      submit.textContent = available && variantId ? `Add ${label}${price ? ` — ${price}` : ''}` : 'Unavailable';
      if (status) status.textContent = `${label} is ${available ? 'available' : 'currently unavailable'}.`;
    };

    packs.forEach((pack) => pack.addEventListener('click', () => selectPack(pack)));
    selectPack(packs.find((pack) => pack.getAttribute('aria-pressed') === 'true') || packs[0]);
  });
})();
